import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import axios from "axios";
import { baseUrl } from "../config";
import { DateIRLToErache } from "../utils/dateConverters";
import { PeriodDetailContent } from "./DetailContent";

export default function PeriodDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [periodDeleteDialog, setPeriodDeleteDialog] = useState(null);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    setError(null);
    axios
      .get(`${baseUrl}/periods/${id}/details`, { withCredentials: true })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.response?.data?.error || err.message);
        setData(null);
        setLoading(false);
      });
  }, [id]);

  const handleEdit = () => {
    if (!data) return;
    navigate(`/edit-period/${data.id}`);
  };

  const handleDeleteClick = () => {
    if (!data) return;
    setPeriodDeleteDialog({ period: data });
  };

  const handleConfirmPeriodDelete = async () => {
    if (!periodDeleteDialog?.period) return;
    try {
      await axios.delete(`${baseUrl}/periods/${periodDeleteDialog.period.id}`, {
        withCredentials: true,
      });
      setPeriodDeleteDialog(null);
      navigate("/periods");
    } catch (_) {
      setPeriodDeleteDialog(null);
    }
  };

  const onOpenDetail = ({ type, id: detailId }) => {
    navigate(type === "event" ? `/events/${detailId}` : `/periods/${detailId}`);
  };

  const canEdit = data?.canEdit;
  const canDelete = data?.canDelete;

  if (loading) return <Box sx={{ p: 2 }}><Typography variant="body2">Chargement…</Typography></Box>;
  if (error) return <Box sx={{ p: 2 }}><Typography variant="body2" color="error">{error}</Typography></Box>;
  if (!data) return null;

  return (
    <>
      <Box sx={{ maxWidth: 720, mx: "auto", p: 2 }}>
        <PeriodDetailContent
          data={data}
          onOpenDetail={onOpenDetail}
          DateIRLToErache={DateIRLToErache}
        />
        {canEdit && (
          <Box sx={{ mt: 2, pt: 2, borderTop: 1, borderColor: "divider", display: "flex", gap: 1 }}>
            <Button variant="outlined" onClick={handleEdit}>
              Éditer
            </Button>
            {canDelete && (
              <Button variant="outlined" color="error" onClick={handleDeleteClick}>
                Supprimer
              </Button>
            )}
          </Box>
        )}
      </Box>

      <Dialog open={!!periodDeleteDialog} onClose={() => setPeriodDeleteDialog(null)}>
        <DialogTitle>Supprimer la période</DialogTitle>
        <DialogContent>
          <p>
            Voulez-vous vraiment supprimer « {periodDeleteDialog?.period?.name} » ? Cette action
            est définitive.
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPeriodDeleteDialog(null)}>Annuler</Button>
          <Button onClick={handleConfirmPeriodDelete} color="error" variant="contained">
            Confirmer la suppression
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
